import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BedIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5 1C3.89543 1 3 1.89543 3 3V5.5C3 5.77614 3.22386 6 3.5 6H4C4.27614 6 4.5 5.77614 4.5 5.5V3.5C4.5 3.22386 4.72386 3 5 3H7C7.27614 3 7.5 3.22386 7.5 3.5V5.5C7.5 5.77614 7.72386 6 8 6C8.27614 6 8.5 5.77614 8.5 5.5V3.5C8.5 3.22386 8.72386 3 9 3H11C11.2761 3 11.5 3.22386 11.5 3.5V5.5C11.5 5.77614 11.7239 6 12 6H12.5C12.7761 6 13 5.77614 13 5.5V3C13 1.89543 12.1046 1 11 1H5Z"
		></path>
		<path
			fill="currentColor"
			d="M2.5 7C1.67157 7 1 7.67157 1 8.5V14.5C1 14.7761 1.22386 15 1.5 15H2.63962C2.85484 15 3.04591 14.8623 3.11396 14.6581L3.65811 13.0257C3.86229 12.4131 4.43549 12 5.08114 12H10.9189C11.5645 12 12.1377 12.4131 12.3419 13.0257L12.886 14.6581C12.9541 14.8623 13.1452 15 13.3604 15H14.5C14.7761 15 15 14.7761 15 14.5V8.5C15 7.67157 14.3284 7 13.5 7H2.5Z"
		></path>
	</svg>
))
